module.exports = __webpack_public_path__ + "static/media/credit_card.97f7ef11.svg";